import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../services/api.service';
import videojs from 'video.js';
import 'videojs-hotkeys';
import 'videojs-sprite-thumbnails';
import 'videojs-contrib-ads';
import 'videojs-ima';

@Component({
  selector: 'app-video-player',
  standalone: true,
  imports: [],
  templateUrl: './video-player.component.html',
  styleUrl: './video-player.component.scss',
})
export class VideoPlayerComponent implements AfterViewInit {
  @ViewChild('target') target: ElementRef | undefined;

  @Input()
  options: any = {
    responsive: true,
    playbackRates: [-2, -1, -0.5, 0.5, 1, 2],
    fluid: true,
  };

  @Input()
  id: string = 'player';

  @Output()
  player_reference = new EventEmitter();

  @Input()
  playable_content: any;

  player: any;

  explore_state: any;

  @Output()
  player_event = new EventEmitter();

  constructor(
    private router: Router,
    private el: ElementRef,
    private apiservice: ApiService
  ) {}

  // Instantiate a Video.js player OnInit
  ngAfterViewInit() {
    let playing_element = videojs(
      <HTMLElement>document.getElementById(this.id),
      this.options
    );
    playing_element.currentTime(this.playable_content?.start_time | 0);

    this.player_reference.emit(playing_element);
    this.player = playing_element;

    // this.player.src({
    //   src:this.playable_content.url,
    //   markers: [
    //     { startTime: this.playable_content.start_time, label: 'Marker st 420' },
    //     { startTime: 1069, label: 'Marker st 1069' }
    //   ],
    // })

    // this.player.formatTime()

    // enable player plugins
    this.player.hotkeys({
      volumeStep: 0.1,
      seekStep: 10,
      enableModifiersForNumbers: false,
    });

    // display thumbnail images on scrubbar
    let sprites_url = this.playable_content.db_data?.metadata?.sprites?.big_player;
    if(this.playable_content.db_data?.metadata?.sprites?.big_player_compressed){
      sprites_url = this.playable_content.db_data?.metadata?.sprites?.big_player_compressed;
    }
    
    if (sprites_url) {
      let sprite_interval = 1;
      if (this.playable_content.db_data.metadata?.sprites?.interval) {
        sprite_interval =
          this.playable_content.db_data.metadata?.sprites?.interval;
      }
      this.player.spriteThumbnails({
        url: encodeURI(this.get_cdn(sprites_url)),
        width: 160,
        height: 90,
        interval: sprite_interval,
        columns: 10,
      });
    }

    // this.include_ads();

    // this.player.markers({
    //   markerStyle: {
    //      'width':'8px',
    //      'background-color': 'red'
    //   },

    //   markers: [
    //      {time: this.playable_content.start_time, text: "marker Starting Time", duration: 20},
    //     //  {time: 12,  text: "is"},
    //     //  {time: 23.6,text: "so"},
    //     //  {time: 28,  text: "cool"}
    //   ]
    // });

    this.player.on('playing', () => {
      this.player_event.emit({
        event: 'playing',
        time: this.player.currentTime(),
      });
    });

    this.player.on('seeking', () => {
      this.player_event.emit({
        event: 'seeking',
        time: this.player.currentTime(),
      });
    });

    this.player.on('seeked', () => {
      this.player_event.emit({
        event: 'seeked',
        time: this.player.currentTime(),
      });
    });

    this.player.on('pause', () => {
      this.player_event.emit({
        event: 'paused',
        time: this.player.currentTime(),
      });
    });

    this.player.on('timeupdate', () => {
      this.player_event.emit({
        event: 'timeupdate',
        time: this.player.currentTime(),
      });
    });
  }


  // Dispose the player OnDestroy
  ngOnDestroy() {
    if (this.player) this.player.dispose();
  }

  click_back() {
    this.router.navigate([
      '/explore',
      { state: { explore_state: this.explore_state } },
    ]);
  }
  get_cdn(url: any) {
    return this.apiservice.Storage_CDN + '/' + url;
  }
}
